import gql from 'graphql-tag'

export const listCreditClients = gql`
	fragment listCreditClients on CreditClientConnection {
		items {
			id
			clientNumber
			name
		}
		total
		hasNextPage
	}
`

export const creditClient = gql`
	fragment creditClient on CreditClient {
		mod_ver
		fa_mod_ver
		mod_ver_isActive
		masterId
		isActive
		clientNumber
		externClientNumber
		name
		groupId
		deliveryAdress
		cashRegisterId
		isCA_Credit
		isCA_Order
		isCA_Employee
		type
		exportType
		StatisticType
		isNoStatistic
		isEdited
		discountValue
		priceCategory
		externalERP_Id
		isExternalERP
		taxSystem
		isNoActiveOnClient
		FA_Id
		shopId
		connectedCRs {
			name
		}
	}
`

export const clients = gql`
	fragment clientsmain on CreditClient {
		isActive
		clientNumber
		name
		deliveryAdress
		isNoActiveOnClient
		shopId
	}
`

export const cashRegisters = gql`
	fragment cashRegisters on CreditClient {
		cashRegisterId
	}
`

export const addClientMain = gql`
	fragment addClientMain on CreditClient {
		name
		clientNumber
	}
`

export const addClientFields = gql`
	fragment addClientFields on CreditClient {
		isActive
		deliveryAdress
		isNoActiveOnClient
	}
`

export const standardOrderItems = gql`
	fragment standardOrderItems on StandardOrderValues {
		id
      	weekAmount
      	weekAmountNew
		weekMinAmount
		weekMaxAmount
      	weekAllottedAmount
		product {
			id
			code
			name
			isActive
		}
	}
`

export const dayOrderItems = gql`
	fragment dayOrderItems on DateOrderValuesConnection {
		total
		items {
			id
			date
			product {
				id
				code
				name
			}
			amount
			minAmount
			maxAmount
			proposedAmount
			allottedAmount
		}
	}
`
export const deliveryNoteItems = gql`
	fragment deliveryNoteItems on DeliveryNoteConnection {
		total
		items {
			id
			number
			date
			total
			isDeleted
		}
	}
`

export const dayOrder = gql`
	fragment dayOrder on DateOrderValues {
		id
		date
		product {
			id
			code
			name
		}
		amount
		minAmount
		maxAmount
		proposedAmount
		allottedAmount
	}
`
export const standardOrder = gql`
	fragment standardOrder on StandardOrderValues {
		id
		product {
			id
			code
			isActive
			name
		}
		weekAmount
      	weekAmountNew
		weekMinAmount
		weekMaxAmount
      	weekAllottedAmount
	}
`
